import { render } from "./VnRules.vue?vue&type=template&id=3c65cadb&scoped=true"
const script = {}

import "./VnRules.vue?vue&type=style&index=0&id=3c65cadb&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c65cadb"

export default script